import {
  Avatar,
  Button,
  Collapse,
  IconButton,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  TablePagination,
  Tooltip,
  FormLabel,
  Typography,
  Divider
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SendIcon from "@material-ui/icons/Send";
import moment from "moment";
import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Header from "../../partials/header";
import Loading from "../loading";
import Snackbar from "../snackbar";
import { styles } from "./style";
import { formatDatetime } from '../../utils/setting'
export class NPS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationList: [],
      totalNotification: 0,
      rowsPerPage: 50,
      page: 0,
      collapse: [],
      show: "received",
    };
  }
  async componentDidMount() {
    const { roleId } = this.props;
    if (roleId.role === "admin") this.getListSentNotification();
    else this.getListReceivedNotification();
  }
  getListReceivedNotification = async () => {
    let notificationList = await this.props.getListReceivedNotification({
      limit: this.state.rowsPerPage,
      page: this.state.page,
      sort: { createdAt: -1 },
    });
    this.setState({
      notificationList:
        notificationList && notificationList.data && notificationList.data.list,
      totalNotification:
        notificationList &&
        notificationList.data &&
        notificationList.data.total,
    });
  };
  getListSentNotification = async () => {
    let notificationList = await this.props.getListSentNotification({
      limit: this.state.rowsPerPage,
      page: this.state.page,
      sort: { createdAt: -1 },
    });
    this.setState({
      notificationList:
        notificationList && notificationList.data && notificationList.data.list,
    });
  };
  timeAgo = (milisecond) => {
    return moment(milisecond).fromNow();
  };
  handlePage = async (notification) => {
    let ids = [notification._id];
    await this.props.updateReader({ ids: ids });
  };
  handleChangePage = (event, page) => {
    const _this = this;
    this.setState({ page }, function () {
      _this.getListReceivedNotification();
    });
  };

  handleChangeRowsPerPage = (event) => {
    const _this = this;
    this.setState({ rowsPerPage: event.target.value }, function () {
      _this.getListReceivedNotification();
    });
  };
  openTemplate = () => {
    this.props.history.push("/notification/template");
  };
  handleOpenCollapes(notification) {
    const id = notification._id;
    const collapse = this.state.collapse;
    if (collapse.indexOf(id) !== -1) collapse.splice(collapse.indexOf(id), 1);
    else collapse.push(id);
    this.setState(collapse);
  }
  handleButton = (button) => {
    this.setState({ show: button });

    if (button === "received") {
      this.getListReceivedNotification();
    } else if (button === "sent") this.getListSentNotification();
  };
  renderDetail = (notification) => {
    const { t, classes } = this.props;
    const { show } = this.state;
    return (
      <Paper square={true} className={classes.containerDetail}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <FormLabel
              className={classes.labelDetail}
            >
              {t('notification_time')}
            </FormLabel>
            {formatDatetime(notification.createdAt)}
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormLabel
              className={classes.labelDetail}
            >
              {t('notification_content')}
            </FormLabel>
            {ReactHtmlParser(notification.data && notification.data.content)}
          </Grid>
          {show === 'sent' &&
            <Grid item xs={12} sm={12}>
              <FormLabel
                className={classes.labelDetail}
              >
                {t('notification_list_users')}
              </FormLabel>
              <List className={classes.rootListDetail}>
                {notification.listToUser &&
                  notification.listToUser.length &&
                  notification.listToUser.map((user) => {
                    return (
                      <ListItem key={user.userCode} alignItems="flex-start">
                        <ListItemAvatar>
                          <Avatar alt={user.email} src={user.avatarImage} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={`${user.lastName} ${user.lastName}`}
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                className={classes.textDetail}
                                color="textPrimary"
                              >
                                {user.email}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    )
                  })}
              </List>
            </Grid>
          }
        </Grid>
      </Paper>
    )
  }
  render() {
    const { t, classes, roleId } = this.props;
    let {
      notificationList = [],
      totalNotification = 0,
      page = 0,
      rowsPerPage = 0,
      collapse,
      show,
    } = this.state;
    const renderActionCustom = () => {
      return (
        <div className={classes.containerButton}>
          <Button
            className={
              show === "received"
                ? classes.buttonActive
                : classes.buttonNonActive
            }
            onClick={() => this.handleButton("received")}
            size="small"
            variant="contained"
          >
            <Tooltip title={t("notification_received_notification")}>
              <CallReceivedIcon />
            </Tooltip>
          </Button>
          <Button
            className={
              show === "sent" ? classes.buttonActive : classes.buttonNonActive
            }
            onClick={() => this.handleButton("sent")}
            size="small"
            variant="contained"
          >
            <Tooltip title={t("notification_sent_notification")}>
              <SendIcon />
            </Tooltip>
          </Button>
        </div>
      );
    };
    return (
      <>
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={
            roleId.role === "admin"
              ? t("sidebar_superadmin")
              : t("sidebar_manage")
          }
          title={
            show === "sent" || roleId.role === "admin"
              ? t("notification_sent_notification")
              : t("notification_received_notification")
          }
          button={t("notification_template")}
          actionButton={() => this.openTemplate()}
          renderActionCustom={
            roleId.role === "admin" ? () => { } : renderActionCustom
          }
        />
        <Paper>
          <List>
            {notificationList.map((ele, index) => {
              let isRead = ele.serviceRead.indexOf(roleId.serviceCode);
              return [
                <ListItem
                  key={index}
                  button
                  divider={true}
                  style={
                    (isRead === -1 && show === "received")
                      ? {
                        backgroundColor: "rgba(163, 164, 168, 0.1)",
                      }
                      : {}
                  }
                  onClick={() => this.handlePage(ele)}
                >
                  <ListItemAvatar>
                    <Avatar>
                      <NotificationsIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    classes={{
                      primary: classes.customListItemTextPrimary,
                      secondary: classes.customListItemTextSecondary,
                    }}
                    primary={
                      <span
                        style={
                          isRead === -1
                            ? {
                              fontWeight: "550",
                            }
                            : {}
                        }
                      >
                        {ele.description}
                      </span>
                    }
                    secondary={this.timeAgo(ele.createdAt)}
                  />
                  <ListItemSecondaryAction>
                    <IconButton
                      onClick={() => this.handleOpenCollapes(ele)}
                    >
                      {collapse.indexOf(ele._id) != -1 ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      )}
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>,
                <Collapse
                  in={collapse.indexOf(ele._id) != -1}
                  key={`collapse-${ele._id}`}
                >
                  {/* <Paper square={true} className={classes.container}>
                    {ReactHtmlParser(ele.data && ele.data.content)}
                  </Paper> */}
                  {this.renderDetail(ele)}
                </Collapse>,
              ];
            })}
          </List>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={totalNotification}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "previous page",
            }}
            nextIconButtonProps={{
              "aria-label": "next page",
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            labelRowsPerPage={t("rows_per_page")}
            labelDisplayedRows={({ from, to, count }) => `${from}- ${to}`}
          />
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  roleId: state.user.user.roleId,
});

const mapDispatch = (dispatch) => ({
  getListReceivedNotification:
    dispatch.notification.getListReceivedNotification,
  getListSentNotification: dispatch.notification.getListSentNotification,
  updateReader: dispatch.notification.updateReader,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: 0 })(NPS)));
